module.exports = __webpack_public_path__ + "img/title7.c8e305f5.png";